var path = 'public/app/features/admin/partials/admin_home.html';
var html = "<navbar model=ctrl.navModel></navbar>\n\n<div class=page-container>\n\t<div class=page-header>\n\t\t<h1>\n\t\t\tServer Administration\n\t\t</h1>\n\t</div>\n\n\t<a class=\"btn btn-inverse\" href=admin/users>\n\t\tManage Users\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/orgs>\n\t\tManage Organizations\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/settings>\n\t\tView Server Settings\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=admin/stats>\n\t\tView Server Stats\n\t</a>\n\n\t<a class=\"btn btn-inverse\" href=styleguide>\n\t  Style guide\n\t</a>\n\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/admin/partials/admin_home.html
// module id = 553
// module chunks = 5